import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCreateAdRequestBody,
  IApiCreateAdResponseBody,
  IApiDeleteAdResponseBody,
  IApiGetAdResponseBody,
  IApiGetAdsRequestBody,
  IApiGetAdsResponseBody,
  IApiUpdateAdRequestBody,
  IApiUpdateAdResponseBody,
} from './AdsApi.types';

export class AdsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    params?: IApiGetAdsRequestBody,
  ): Promise<IApiGetAdsResponseBody> {
    const request: IApiJsonRequest = {
      path: '/advertisements',
      method: 'get',
      params,
    };

    const document = await this.client.fetchJson<IApiGetAdsResponseBody>(
      request,
      { appId },
    );

    return document.body;
  }

  public async get(
    appId: string,
    adId: string,
  ): Promise<IApiGetAdResponseBody> {
    const request: IApiJsonRequest = {
      path: `/advertisements/${adId}`,
      method: 'get',
    };

    const document = await this.client.fetchJson<IApiGetAdResponseBody>(
      request,
      { appId },
    );

    return document.body;
  }

  public async create(
    appId: string,
    body: IApiCreateAdRequestBody,
  ): Promise<IApiCreateAdResponseBody> {
    const request: IApiJsonRequest = {
      path: '/advertisements',
      method: 'post',
      body,
    };

    const document = await this.client.fetchJson<IApiCreateAdResponseBody>(
      request,
      { appId },
    );

    return document.body;
  }

  public async update(
    appId: string,
    adId: string,
    body: IApiUpdateAdRequestBody,
  ): Promise<IApiUpdateAdResponseBody> {
    const request: IApiJsonRequest = {
      path: `/advertisements/${adId}`,
      method: 'patch',
      body,
    };

    const document = await this.client.fetchJson<IApiUpdateAdResponseBody>(
      request,
      { appId },
    );

    return document.body;
  }

  public async delete(
    appId: string,
    adId: string,
  ): Promise<IApiDeleteAdResponseBody> {
    const request: IApiJsonRequest = {
      path: `/advertisements/${adId}`,
      method: 'delete',
    };

    const document = await this.client.fetchJson<IApiDeleteAdResponseBody>(
      request,
      { appId },
    );

    return document.body;
  }
}
